<template>
  <div>
    <div class="event-full-nav-overlay" :class="{ 'is-visible': isActive }">
      <internal-nav-defiling-text :title="title"></internal-nav-defiling-text>
    </div>
    <div
      v-if="anchors.length > 1"
      class="event-full-nav"
      :class="{ 'is-active': isActive }"
      @mouseenter="isActive = true"
      @mouseleave="closeNavIfDesktop"
    >
      <div class="event-full-nav-title">{{ title }}</div>
      <internal-nav-anchors
        :anchors="anchors"
        :currentIndex="currentIndex"
        @toggleActive="value => (isActive = value)"
      ></internal-nav-anchors>
      <a
        v-if="linkUrl && linkLabel"
        class="event-full-nav-link"
        :href="linkUrl"
        target="_blank"
      >
        <i class="fal fa-globe"></i>
        <span>{{ linkLabel }}</span>
      </a>
      <a v-if="backLinkUrl && backLinkLabel" class="event-full-nav-back" :href="backLinkUrl">
        <i class="fas fa-arrow-left"></i>
        <span>{{ backLinkLabel }}</span>
      </a>
      <internal-nav-current
        :anchors="anchors"
        @setCurrent="index => (currentIndex = index)"
      ></internal-nav-current>
    </div>
    <internal-nav-help></internal-nav-help>
    <div
      class="event-full-nav-hide"
      :class="{ 'is-active': isActive }"
      @click="isActive = false"
    >
      <i class="fas fa-arrow-left"></i> Hide
    </div>
    <div
      v-if="anchors.length > 1"
      class="event-full-nav-trigger"
      @click="isActive = true"
    >
      <i class="fas fa-layer-group"></i>
    </div>
  </div>
</template>

<script>
import InternalNavAnchors from '@/components/nav/InternalNavAnchors'
import InternalNavCurrent from '@/components/nav/InternalNavCurrent'
import InternalNavHelp from '@/components/nav/InternalNavHelp'
import InternalNavDefilingText from '@/components/nav/InternalNavDefilingText'

export default {
  components: {
    InternalNavAnchors,
    InternalNavCurrent,
    InternalNavHelp,
    InternalNavDefilingText
  },
  props: {
    title: String,
    linkUrl: String,
    linkLabel: String,
    backLinkUrl: String,
    backLinkLabel: String
  },
  data() {
    return {
      anchors: [],
      isActive: false,
      currentIndex: null
    }
  },
  mounted() {
    this.getAnchors()
  },
  methods: {
    getAnchors() {
      const elements = document.querySelectorAll(
        '[data-anchor]:not(.unpublished)'
      )

      elements.forEach(element => {
        this.anchors.push({
          id: element.dataset.anchor,
          label: element.dataset.anchorLabel
        })
      })
    },
    closeNavIfDesktop() {
      if (window.innerWidth >= 1340) {
        this.isActive = false
      }
    }
  },
  watch: {
    isActive(value) {
      if (value) {
        document.querySelector('body').classList.add('is-scroll-disabled')
      } else {
        document.querySelector('body').classList.remove('is-scroll-disabled')
      }
    }
  }
}
</script>

<style lang="scss">
.event-full-nav {
  position: fixed;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}

.event-full-nav-back {
  width: 65px;
  height: 50px;
  padding-right: 2px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-bottom: solid 1px rgba(#fff, 0.1);
  color: #fff;
  font-size: 20px;

  i {
    font-weight: 400;
  }
}

.event-full-nav-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: linear-gradient(
    160deg,
    rgba(0, 231, 0, 0.75) 0%,
    rgba(165, 52, 255, 0.75) 60%
  );
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  opacity: 0;
  transition: opacity 0.2s;

  &.is-visible {
    opacity: 1;
  }
}
</style>
